import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ContentProvider } from "./context/ContentContext";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import Home from "./pages/Home";
import MusicPage from "./pages/MusicPage";
import TeamsPage from "./pages/TeamsPage";
import ContactPage from "./pages/ContactPage";
import NosotrosPage from "./pages/NosotrosPage";
import { SeriesCineTVPage } from "./pages/music/SeriesCineTVPage";
import AudioBrandingPage from "./pages/music/AudioBrandingPage";
import ProduccionArtisticaPage from "./pages/music/ProduccionArtisticaPage";
import TeamsCuentaConmigoPage from "./pages/teams/TeamsCuentaConmigoPage";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ContentProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/music" element={<MusicPage />} />
              <Route path="/music/audio-branding" element={<AudioBrandingPage />} />
              <Route path="/music/series-cine-tv" element={<SeriesCineTVPage />} />
              <Route path="/music/produccion-artistica" element={<ProduccionArtisticaPage />} />
              <Route path="/teams" element={<TeamsPage />} />
              <Route path="/teams/cuenta-conmigo" element={<TeamsCuentaConmigoPage />} />
              <Route path="/nosotros" element={<NosotrosPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminDashboard />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster />
        </ContentProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
